module.exports = __webpack_public_path__ + "static/media/Strip.88807171.mp4";